import { render, staticRenderFns } from "./issuePlatformDialog.vue?vue&type=template&id=16209093&"
import script from "./issuePlatformDialog.vue?vue&type=script&lang=js&"
export * from "./issuePlatformDialog.vue?vue&type=script&lang=js&"
import style0 from "./issuePlatformDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports